<script>
    import { page } from "$app/stores";
    import Prose from "./Prose.svelte";


    let className = "";
    export { className as class };
    export let key = "story_mission";

    const text = $page.data[key];

</script>


<Prose xl class="mx-auto prose-headings:text-center prose-headings:mb-8 {className}">
    {@html text}
</Prose>